import React from "react";

const MenuIcon = () => {
  return (
    <div>
      <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0625 18.375C13.0625 18.922 12.8452 19.4466 12.4584 19.8334C12.0716 20.2202 11.547 20.4375 11 20.4375C10.453 20.4375 9.92839 20.2202 9.54159 19.8334C9.1548 19.4466 8.9375 18.922 8.9375 18.375C8.9375 17.828 9.1548 17.3034 9.54159 16.9166C9.92839 16.5298 10.453 16.3125 11 16.3125C11.547 16.3125 12.0716 16.5298 12.4584 16.9166C12.8452 17.3034 13.0625 17.828 13.0625 18.375ZM13.0625 11.5C13.0625 12.047 12.8452 12.5716 12.4584 12.9584C12.0716 13.3452 11.547 13.5625 11 13.5625C10.453 13.5625 9.92839 13.3452 9.54159 12.9584C9.1548 12.5716 8.9375 12.047 8.9375 11.5C8.9375 10.953 9.1548 10.4284 9.54159 10.0416C9.92839 9.6548 10.453 9.4375 11 9.4375C11.547 9.4375 12.0716 9.6548 12.4584 10.0416C12.8452 10.4284 13.0625 10.953 13.0625 11.5ZM13.0625 4.625C13.0625 5.17201 12.8452 5.69661 12.4584 6.08341C12.0716 6.4702 11.547 6.6875 11 6.6875C10.453 6.6875 9.92839 6.4702 9.54159 6.08341C9.1548 5.69661 8.9375 5.17201 8.9375 4.625C8.9375 4.07799 9.1548 3.55339 9.54159 3.16659C9.92839 2.7798 10.453 2.5625 11 2.5625C11.547 2.5625 12.0716 2.7798 12.4584 3.16659C12.8452 3.55339 13.0625 4.07799 13.0625 4.625Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default MenuIcon;
